<script lang="ts">
  export interface VBaseLayoutProps {
    title?: string;
  }

  export const defaultTitle = 'Wiren Board Cloud';
</script>

<script lang="ts" setup>
  const props = defineProps<VBaseLayoutProps>();

  watch(
    () => props.title,
    () => {
      useTitle(props.title ? `${props.title} | ${defaultTitle}` : defaultTitle);
    },
    { immediate: true },
  );
</script>

<template>
  <div>
    <slot />
  </div>
</template>
